/*
 * @Author: liuxw@codoon.com
 * @Date: 2022-06-29 14:50:09
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 16:41:34
 */
import icClose from "../../../assets/imgs/closeCert.png";

import React, { FC, memo, useCallback, useEffect, useState } from "react";
import { IActivityInfo } from "../../../service/activity/interface";
import { IPostCreateTempDetail, IUserinfo } from "../../../service/Index";
import Modal from "../../Common/Modal/Modal";
import { jumpToUrlPair } from "../urlTransform";
import "./index.less";
import classNames from "classnames";
import { tempBtnColorSelecor } from "../../../store/common/selector";
import { connect } from "react-redux";
import { fillUserIdInUrl } from "../../../pages/utils";

const PREFIX = "OtherRewardModal";

/* 弹窗配置 */
export interface IOtherRewardModalConf {
  img: string; // 弹窗图片
  url?: string; // 点击跳转链接
}

type IProps = {
  // 其实 conf 为 null 都可以用来表示 弹窗关闭的
  // 但 conf 为 null，弹窗内容就没了，关闭动画执行时，需保留内容
  visible: boolean;
  conf: IOtherRewardModalConf | null;
  onClose: () => void;
  activity_id: string;
  user_info: IUserinfo;
};

/**
 * 其它奖励 弹窗
 * 从以前的证书弹窗中，单独拎出来了
 */
const OtherRewardModal: FC<IProps> = memo(
  ({ conf, onClose, activity_id, user_info, visible }) => {
    const handleClickModal = useCallback(() => {
      const reward_url = conf?.url;
      if (reward_url) {
        const fillUrl = fillUserIdInUrl(reward_url, user_info.id || "");
        jumpToUrlPair(fillUrl);
      }
    }, [activity_id, conf, user_info]);

    return (
      <Modal
        visible={visible && !!conf}
        animation={"fade"}
        onClose={onClose}
        className={PREFIX}
        style={{
          width: "292px",
          height: "fit-content",
          position: "absolute",
          top: "50%",
          backgroundColor: "#fff",
          borderRadius: "10px",
          left: "50%",
          transform: "translate(-50%,-50%)",
          fontSize: "PingFang SC Medium",
          overflow: "hidden",
        }}
      >
        <div
          className={classNames(`${PREFIX}-body`, {
            ["is-clickable"]: !!conf?.url,
          })}
          onClick={handleClickModal}
        >
          <img src={conf?.img} className={`${PREFIX}-bodyCover`} />
          <div
            className={`${PREFIX}-bodyClose`}
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            <img src={icClose} className={`${PREFIX}-bodyCloseIcon`} />
          </div>
        </div>
      </Modal>
    );
  }
);

export default OtherRewardModal;
